export const CUSTOM_DATE_INTERVAL_VALUE = 'calendar';

export const DATE_INTERVALS = [
  {label: 'D', value: 'lastDay'},
  {label: 'W', value: 'lastWeek'},
  {label: 'M', value: 'lastMonth'},
  {label: 'All', value: 'all'},
  {label: 'C', value: CUSTOM_DATE_INTERVAL_VALUE, icon: 'calendar'},
];

export const DATE_INTERVAL_DIFFERENCE = {
  lastDay: 1,
  lastWeek: 7,
  lastMonth: 30,
  all: -1,
  [CUSTOM_DATE_INTERVAL_VALUE]: null,
};

export const DATE_INTERVAL_SELECT_ITEM_CLASS = 'date-interval-select_item';

export const AUDITED_DEVICES_VALUE = 'audit';
export const CAPTURED_DEVICES_VALUE = 'capture';
export const DISCOVERED_DEVICES_VALUE = 'discover';
export const PROVISIONED_DEVICES = 'prov';
export const UPGRADED_DEVICES = 'osm';

export const DATASETS_OPTIONS = [
  {value: AUDITED_DEVICES_VALUE, label: 'Audited devices'},
  // { value: "Audit policies", label: "Audit policies" },
  {value: CAPTURED_DEVICES_VALUE, label: 'Captured devices'},
  {value: DISCOVERED_DEVICES_VALUE, label: 'Discovered devices'},
  // { value: "OS Plans", label: "OS Plans" },
  {value: PROVISIONED_DEVICES, label: 'Provisioned devices'},
  // { value: "Provisionings", label: "Provisionings" },
  {value: UPGRADED_DEVICES, label: 'Upgraded devices'},
];
interface ILabelsMapping {
  [key: string]: ILabelOptions;
}

interface ILabelOptions {
  successCount: string;
  failedCount: string;
}

export const LABELS_MAPPING: ILabelsMapping = {
  [PROVISIONED_DEVICES]: {
    successCount: 'Successful',
    failedCount: 'Unsuccessful',
  },
  [AUDITED_DEVICES_VALUE]: {
    successCount: 'Passed',
    failedCount: 'Failed',
  },
  [UPGRADED_DEVICES]: {
    successCount: 'Successful',
    failedCount: 'Unsuccessful',
  },
  [CAPTURED_DEVICES_VALUE]: {
    successCount: 'Unchanged',
    failedCount: 'Changed',
  },
  [DISCOVERED_DEVICES_VALUE]: {
    successCount: 'Successful',
    failedCount: 'Unsuccessful',
  },
};

export const FORM_TITLE_PLACEHOLDER = 'Input title';
export const FORM_DATASETS_PLACEHOLDER = 'Select datasets';
